module.exports = __webpack_public_path__ + "img/icon-location.d1c62116.svg";